export default __webpack_public_path__ + "static/media/withdraw-ecredit-step2.be3d45e9.png";